
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import vClickOutside from 'click-outside-vue3';
import { app, Root } from '@/main';
import { CustomDropdownViewModel } from '@/entities/CustomDropdownViewModel';
@Component({
  components: {
    vClickOutside,
  },
})
class CustomDropdown extends Vue {
  @Prop() private customDropdowmData!: CustomDropdownViewModel[];
  @Prop() private selectedFilterId!: number;
  @Prop() private emptyPlaceholder!: string;
  private localCustomDropdownData: CustomDropdownViewModel[] = [];
  private showDropDown = false;
  private placeholder = 'Select a filter or create one';
  private selectedItem = { Id: 0, Name: ''};
  private tickIcon = require('@/assets/Images/tick-icon.svg');
  private crossIcon = require('@/assets/Images/blue-cross-icon.svg');
  private arrowDownIcon = require('@/assets/Images/arrow-down.svg');
  private isMounted = false;

  get showTickIcon() {
    return this.localCustomDropdownData.some((item) => item.Id === this.selectedItem.Id);
  }
  private mounted() {
    this.isMounted = true;
    if(!!this.customDropdowmData) {
      this.localCustomDropdownData = this.customDropdowmData;
      this.localCustomDropdownData.sort((item1, item2) => item1.Name.toLowerCase() > item2.Name.toLowerCase() ? 1 : -1);
    }
    // Set selected filter
    if (!!this.selectedFilterId) {
      this.selectedItem.Id = this.selectedFilterId;
      const filter = this.localCustomDropdownData.find((item) => item.Id === this.selectedFilterId);
      this.selectedItem.Name = !!filter ? filter.Name : '';
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    app.use(vClickOutside);
  }
  private ToggleDropDown() {
    this.showDropDown = !this.showDropDown;
  }
  private HideDropDown() {
    this.showDropDown = false;
  }
  // Filter selected from dropdown
  private SelectFilter(val: {Id: number; Name: string}) {
    this.selectedItem = val;
    this.$emit('set-selected-filter-id', this.selectedItem.Id);
  }
  // Selected filter Id to edit
  private EditItem(id: number) {
    Root.emit('selected-audience-filter-id', id);
  }
  // Get text to be shown in the filter input field
  private GetFilterText() {
    return this.selectedItem === null || this.selectedItem === undefined || this.selectedItem.Id === 0 ? this.placeholder : this.selectedItem.Name;
  }
  // Remove selected filter
  private RemoveItem() {
    this.selectedItem = {Id: 0, Name: ''};
    // Remove selected filter item iD
    this.$emit('set-selected-filter-id', 0);
  }
}
export default toNative(CustomDropdown);
